// src/features/commission/components/CommissionOrderCard.tsx
import { Card, formatPersianNumber } from '../../../app/components/foundation';
import type { Commission } from '../types/commission.types';

export interface CommissionOrderCardProps {
  commission: Commission;
}

/**
 * Workspace card: which order this commission was generated from.
 * Pulls orderId/orderNumber/orderAmount straight off the base
 * Commission record — same self-contained approach as
 * orders/components/OrderServiceCard.tsx, this feature does not
 * import from features/orders.
 */
export function CommissionOrderCard({ commission }: CommissionOrderCardProps) {
  return (
    <Card className="vania-commission-workspace-card">
      <h2 className="vania-commission-workspace-card-title">سفارش</h2>

      <dl className="vania-commission-workspace-fieldlist">
        <div>
          <dt>نوع منبع</dt>
          <dd>{commission.source_type}</dd>
        </div>
        <div>
          <dt>شناسه منبع</dt>
          <dd dir="ltr">{commission.source_id}</dd>
        </div>
        <div>
          <dt>مبلغ تراکنش</dt>
          <dd dir="ltr">{formatPersianNumber(commission.source_amount ?? 0)} تومان</dd>
        </div>
      </dl>
    </Card>
  );
}
